<template>
  <div class="avatar">
    <div class="avatar__picture">
      <img class="avatar__symbol" :src="avatar + '&background=0A76BD'" :alt="name" />
    </div>
  </div>
</template>

<script>
import { get_config } from "@src/utilities"

export default {
  name: 'avatar',

  data() {
    return {
      avatar: '',
      name: '',
    }
  },

  mounted() {
    this.avatar = get_config('integration.avatarSrc', '')
    this.name = get_config('integration.displayName', '')
  },
}
</script>

<style lang="scss" scoped>

  .avatar {
    border: 1px solid $gray-300;
    padding: $grid-gutter-width / 3;
    border-radius: 50px;
    display: flex;
    align-items: center;
    background-color: $white;
    cursor: pointer;

    &__picture {
      width: 30px;
      height: 30px;
      overflow: hidden;
      border-radius: 50%;

      img {
        max-width: 100%;
      }
    }
  }

</style>